<template>
  <div class="manage-header">
    <div class="left">
      <!-- <img :src="logo" /> -->
      <span>青藤管理后台</span>
    </div>
    <div class="right">
      <!-- <img :src="control" @click="toControl"/> -->
      <el-tooltip placement="bottom" effect="light" :visible-arrow="false" popper-class="tool">
        <div slot="content">
          <div class="logout" @click="logout">退出登录</div>
          <div class="logout" @click="changePass">修改密码</div>
        </div>
        <div class="header-left">
          <img :src="user">
          <div class="user-name">{{ userName }}</div>
        </div>
      </el-tooltip>
    </div>

    <Dialogs title="修改密码" :is-show-dialog="isShowPage" width="30%" @handleClick="handleClose" :noBorderTop="true">
      <div slot="content">
        <ChangePassword @close="handleClose"></ChangePassword>
      </div>
      <div slot="btns"></div>
    </Dialogs>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { clearLoginInfo } from '@/utils'
import Dialogs from '@/components/page/Dialogs.vue'
import ChangePassword from './changePassword'
export default {
  components: {
    Dialogs,
    ChangePassword
  },
  data () {
    return {
      logo: require('@/assets/img/header.png'),
      user: require('@/assets/img/user.png'),
      control: require('@/assets/img/control.png'),
      isShowPage: false
    }
  },
  computed: {
    ...mapState({
      userName: state => state.user.name
    })
  },
  methods: {
    toControl () {
      this.$router.push('/control')
    },
    logout () {
      this.$http({
        url: this.$http.adornUrl('/qtSysapi/logOut'),
        method: 'post',
        data: this.$http.adornData()
      }).then(() => {
        clearLoginInfo()
        location.href = '/login'
      })
    },
    changePass () {
      this.isShowPage = true
    },
    handleClose () {
      this.isShowPage = false
    }
  }
}
</script>
<style lang="scss">
.tool {
  background: #fff !important;
  border: 0px solid #08150F !important;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.2) !important;
  border-radius: 5px !important;
  padding: 10px 15px !important;
  text-align: center;
  .logout {
    font-size: 14px;
    font-family: MiSans;
    color: #606266;
  }
  .logout {
    margin-top: 10px;
    cursor: pointer;
    &:hover {
      color: #00af84;
    }
  }
}
</style>
<style lang="scss" scoped>
.manage-header{
  height: 80px;
  padding: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #303248;
  color:#FFFFFF;
  .left {
    display: flex;
    align-items: center;
    img {
      width: 158px;
      height: 53px;
      margin-left: 22px;
      margin-right: 43px;
    }
    span {
      font-weight: 500;
      font-size: 36px;  
      line-height: 53px;
    }
  }
  .right {
    display: flex;
    align-items: center;
    img{
      margin-left: 27px;
      cursor: pointer;
    }
    .header-left {
      display: flex;
      align-items: center;
      cursor: pointer;
    }
    .user-name, .logout {
      font-size: 13px;
      font-family: MiSans;
      margin-left: 8px;
    }
  }
}
</style>